import dependencyInjectionDefinition from './wallet-accounts.js';
export const create = dependencyInjectionDefinition.factory;
export { default } from './wallet-accounts.js';
